<template>
  <div>
    <div class="appui">
      <div class="appui-head">
        <div>
          <h1 class="appui-title">Notificações</h1>
          <div class="appui-crumb">App <span class="sep">/</span> Notificações</div>
        </div>
      </div>

      <div class="appui-notif-grid">
        <!-- Composer -->
        <section class="appui-card" style="padding:22px 24px;align-self:start">
          <h2 class="appui-sec-title">Novo aviso</h2>
          <p class="appui-sec-sub">Push para todos os participantes com o app instalado.</p>
          <form @submit.prevent="create()">
            <div style="margin-bottom:14px">
              <label class="appui-label">Título *</label>
              <input type="text" class="appui-input" v-model="form.title" maxlength="80" required>
            </div>
            <div style="margin-bottom:14px">
              <label class="appui-label">Mensagem *</label>
              <textarea class="appui-input" style="min-height:90px" v-model="form.message" maxlength="240" required></textarea>
              <div style="font-size:10.5px;color:#adb5bd;text-align:right;margin-top:3px">{{ (form.message || '').length }}/240</div>
            </div>
            <div style="margin-bottom:16px">
              <label class="appui-label">Agendar para</label>
              <input type="datetime-local" class="appui-input" v-model="form.scheduled_at">
              <div style="font-size:11px;color:#adb5bd;margin-top:4px">Deixe em branco para enviar agora.</div>
            </div>

            <!-- Prévia do push -->
            <div class="appui-push-preview">
              <div class="appui-push-app"><i class="mdi mdi-cellphone"></i> Prévia no celular</div>
              <div class="appui-push-title">{{ form.title || 'Título do aviso' }}</div>
              <div class="appui-push-msg">{{ form.message || 'A mensagem aparece assim na notificação do participante.' }}</div>
            </div>

            <button type="submit" class="appui-btn appui-btn--primary" style="width:100%;margin-top:16px" :disabled="saving">
              <span v-if="saving">Enviando...</span>
              <span v-else><i class="mdi" :class="form.scheduled_at ? 'mdi-clock-outline' : 'mdi-send'"></i> {{ form.scheduled_at ? 'Agendar envio' : 'Enviar agora' }}</span>
            </button>
          </form>
        </section>

        <!-- Histórico -->
        <section class="appui-card appui-card--flush">
          <div class="appui-card-toolbar">
            <div class="appui-card-toolbar-left"><span class="appui-sec-title">Histórico</span></div>
            <div class="appui-card-toolbar-right">
              <button class="appui-btn appui-btn--ghost appui-btn--sm" @click="load()"><i class="mdi mdi-refresh mr-1"></i> Atualizar</button>
            </div>
          </div>

          <div v-if="!list.length" class="appui-inline-empty">Nenhum aviso enviado ainda.</div>
          <div v-else>
            <div v-for="n in list" :key="n.id" class="appui-notif-row">
              <span class="appui-notif-dot" :class="'is-' + (n.status || 'pending')"></span>
              <div style="flex:1;min-width:0">
                <div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap">
                  <span style="font-weight:600;font-size:13px;color:#495057">{{ n.title }}</span>
                  <span class="appui-badge" :class="badgeClass(n.status)">{{ statusLabel(n.status) }}</span>
                </div>
                <div style="font-size:12px;color:#74788d;margin-top:2px">{{ n.message }}</div>
                <div style="font-size:11px;color:#adb5bd;margin-top:3px"><i class="mdi mdi-clock-outline"></i> {{ formatWhen(n) }}</div>
              </div>
              <div style="flex:none;white-space:nowrap">
                <button v-if="n.status !== 'sent'" class="appui-tbtn appui-tbtn--primary" style="margin-right:6px" title="Enviar agora" @click="send(n)"><i class="mdi mdi-send"></i> Enviar</button>
                <button class="appui-tbtn appui-tbtn--danger" @click="remove(n)">Excluir</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { errorMessage, successMessage } from '@/components/alertsMessages'
import services from './services'
import './app-ui.css'

export default {
  components: {},
  name: 'app-notifications',
  data () {
    return {
      form: { title: '', message: '', scheduled_at: '' },
      list: [],
      saving: false
    }
  },
  mounted () { this.load() },
  methods: {
    load () {
      services.listNotifications({ limit: 50 })
        .then(res => { this.list = res.data.data })
        .catch(() => errorMessage('Falha ao carregar notificações.', 3000))
    },
    async create () {
      this.saving = true
      try {
        const res = await services.createNotification({
          title: this.form.title,
          message: this.form.message,
          scheduled_at: this.form.scheduled_at || null
        })
        successMessage(res.data.message || 'Notificação criada.', 2500)
        this.form = { title: '', message: '', scheduled_at: '' }
        this.load()
      } catch (e) {
        errorMessage(e?.response?.data?.message || 'Falha ao criar notificação.', 3500)
      } finally { this.saving = false }
    },
    async send (n) {
      try {
        const res = await services.sendNotification(n.id)
        successMessage(res.data.message || 'Enviada.', 2500)
        this.load()
      } catch (e) { errorMessage('Falha ao enviar.', 3000) }
    },
    async remove (n) {
      const ok = await this.$bvModal.msgBoxConfirm('Remover esta notificação?', { okTitle: 'Remover', cancelTitle: 'Cancelar', okVariant: 'danger' })
      if (!ok) return
      try { await services.deleteNotification(n.id); this.load() } catch (e) { errorMessage('Falha ao remover.', 3000) }
    },
    statusLabel (s) { return s === 'sent' ? 'Enviada' : (s === 'failed' ? 'Falhou' : 'Pendente') },
    badgeClass (s) { return s === 'sent' ? 'appui-badge--green' : (s === 'failed' ? 'appui-badge--red' : 'appui-badge--muted') },
    formatWhen (n) {
      const d = n.sent_at || n.scheduled_at || n.created_at
      if (!d) return '—'
      const dt = new Date(String(d).replace(' ', 'T'))
      if (isNaN(dt)) return d
      const label = dt.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
      if (n.status !== 'sent' && n.scheduled_at) return 'Agendada para ' + label
      return label
    }
  }
}
</script>
